/**
 * Category:
 * HKCTC Reports - HKCTC_REPORT
 * T&C services - TC_SERVICES
 * Career development - CAREER_DEVELOPMENT
 *
 * platform:
 * File - FILE
 * YouTube - YOUTUBE
 *
 * type:
 * PDF - PDF
 * Video - VIDEO
 * */
import videos_en from "./videos-en.json";
import videos_tc from "./videos-tc.json";
import { MEDIA_TYPE } from "../PublicationList_left";

export enum VIDEO_TYPE {
  HKCTC_REPORT = "HKCTC_REPORT",
  TC_SERVICES = "TC_SERVICES",
  CAREER_DEVELOPMENT = "CAREER_DEVELOPMENT",
  MANPOWER_DEVELOPMENT = "MANPOWER_DEVELOPMENT",
}

export type VideoListData = {
  title: string;
  url: string;
  platform: "FILE" | "YOUTUBE";
  cate: VIDEO_TYPE[];
  type: MEDIA_TYPE;
};

const processVideosJson = (jsonData: any[]): VideoListData[] => {
  return jsonData?.map((item) => ({
    title: item?.title ?? "",
    url: item?.url ?? "",
    platform: item?.platform as "FILE" | "YOUTUBE",
    cate: item?.cate as VIDEO_TYPE[],
    type: MEDIA_TYPE.VIDEO,
  }));
};

export const videos_list_en: VideoListData[] = processVideosJson(videos_en);

export const videos_list_tc: VideoListData[] = processVideosJson(videos_tc);
